// src/components/ReaderItemActions.jsx
//
// Compact per-item action bar for the readers: a bookmark toggle + a "Notes" button for the
// ACTIVE content item. Presentational only -- the reader owns the bookmark state (useBookmarks)
// and the notes-panel open state, and passes them in. Rendered OUTSIDE .analysis-content so it
// is clickable chrome (content-protection never blocks it).
import React from 'react';
import { IconBookmark, IconEdit } from './icons.jsx';

export default function ReaderItemActions({ isBookmarked, onToggleBookmark, onOpenNotes }) {
    return (
        <div className="flex items-center justify-end gap-2 mb-3">
            <button
                onClick={onToggleBookmark}
                aria-pressed={!!isBookmarked}
                title={isBookmarked ? 'Remove bookmark' : 'Bookmark this section'}
                className={`flex items-center gap-1.5 px-3 py-1.5 min-h-[44px] md:min-h-0 border font-display text-sm transition-colors font-medium rounded-full ${
                    isBookmarked
                        ? 'border-book-accent bg-book-accent/15 text-book-accent'
                        : 'border-book-accent/40 text-book-muted hover:text-book-accent hover:border-book-accent/60'
                }`}>
                <IconBookmark className="w-3.5 h-3.5" />
                <span>{isBookmarked ? 'Saved' : 'Save'}</span>
            </button>
            <button
                onClick={onOpenNotes}
                title="Open my notes for this section"
                className="flex items-center gap-1.5 px-3 py-1.5 min-h-[44px] md:min-h-0 border border-book-accent/40 text-book-muted hover:text-book-accent hover:border-book-accent/60 font-display text-sm transition-colors font-medium rounded-full">
                <IconEdit className="w-3.5 h-3.5" />
                <span>Notes</span>
            </button>
        </div>
    );
}
